export enum Role {
    TITULAIRE = 'TITULAIRE',
    GESTIONNAIRE = 'GESTIONNAIRE',
    UTILISATEUR = 'UTILISATEUR',
}
